<template>
  <card>
    <language-list
      v-model="params['locale']"
      :isAll="true"
      @input="params['page'] = 1"
    />
    <list
      :params="params"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      :setImport="true"
      :exportFields="exportFields"
    />
  </card>
</template>
<script>
export default {
  name: "groups",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        Класс: {
          field: "title",
          callback: (value) => {
            return value && value!==" " ? value + " класс" : "Нет названия";
          },
        },
        "Локализация": "locale",
      },
      params: {},
      val: [],
      modalCreate: "group",
      fields: [
        {
          key: "title",
          label: "Класс (буква)",
          type: "field",
          textType: "text",
        },
        {
          col: "col-12 col-md-6",
          key: "locale",
          label: "Локализация класса",
          type: "locale",
        },
        {
          col: "col-12 col-md-6",
          label: "Для классов",
          key: "course_id",
          type: "course",
        },
        {
          col: "col-12 col-md-6",
          label: "Сезон",
          key: "season",
          type: "select",
          selectKey: "title",
          modal: "season",
          prefix: "group_select_sesason",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_group",
      itemLink: "business/groups",
      setLink: "business/groups",
      columns: [
        {
          key: "title",
          title: "Класс",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "locale",
          title: "Локализация класса",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "course",
          title: "Номер курса",
          disableLink: true,
          object: "title",
        },
        {
          detail: true,
          remove: false,
        },
      ],
    };
  },
};
</script>
<style>
</style>
